module.exports = __webpack_public_path__ + "static/media/3@2x.5f75fda2.png";